import Item from 'src/models/Item.model'

class Group {
  constructor (_group) {
    if (_group !== undefined) {
      this.id = _group.id ? _group.id : null
      this.name = _group.name ? _group.name : ''
      this.description = _group.description ? _group.description : ''
      this.items = _group.items ? _group.items : []
      this.order = _group.order ? _group.order : null
      this.optional = _group.optional ? _group.optional : false
      this.semaphore_standard = !_group.semaphore_standard || _group.semaphore_standard.length === 0 ? {} : _group.semaphore_standard
    } else {
      this.id = null
      this.name = ''
      this.description = ''
      this.items = []
      this.order = null
      this.optional = false
      this.semaphore_standard = {}
    }
  }

  set items (_items) {
    const itemsArray = []
    _items.forEach((item) => {
      itemsArray.push(new Item(item))
    })
    this._items = itemsArray
  }

  get items () {
    return this._items
  }

  get real_value () {
    let total = 0
    this.items.forEach((item) => {
      total += item.real_value
    })
    return total
  }

  get max_value () {
    let total = 0
    this.items.forEach((item) => {
      total += item.max_value
    })
    return total
  }

  get averageInGroup () {
    let total = 0
    let counter = 0
    this.items.forEach((item) => {
      if (item.max_value) {
        counter++
        const avg = item.real_value / item.max_value
        total += avg
      }
    })
    if (counter > 0) {
      return total / counter
    }
    return 0
  }

  addItem (new_item) {
    this.items.push(new_item)
  }

  removeItem (index) {
    this.items.splice(index, 1)
  }
}

export default Group
